import { SUPPORTED_CV_LANGUAGE_NAMES } from '@tabbio/utils/cv-languages';

export function findCvLanguageSuggestions(
  query: string,
  existingNames: readonly string[],
  limit = Number.POSITIVE_INFINITY,
) {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  if (!normalizedQuery) return [];
  const existing = new Set(existingNames.map((name) => name.toLocaleLowerCase()));
  return SUPPORTED_CV_LANGUAGE_NAMES.filter(
    (language) =>
      !existing.has(language.toLocaleLowerCase()) &&
      language.toLocaleLowerCase().includes(normalizedQuery),
  ).slice(0, limit);
}
